<div class="content">
  <app-report-page-header
    [reportCount]="reports.length"
    [loading]="carregandoCatalogo" />

  <app-report-general-filters
    [periods]="periodos"
    [clients]="clientes"
    [posts]="postos"
    [formats]="formatos"
    [(selectedPeriod)]="periodoSelecionado"
    [selectedClient]="clienteSelecionado"
    (selectedClientChange)="onClienteChange($event)"
    [(selectedPost)]="postoSelecionado"
    [(selectedFormat)]="formatoSelecionado"
    [loadingClients]="carregandoClientes"
    [loadingPosts]="carregandoPostos" />

  <app-report-catalog
    [reports]="reports"
    [loading]="carregandoCatalogo"
    [loadFailed]="falhaAoCarregarCatalogo"
    [generating]="gerandoDocumento"
    (retryRequested)="carregarConfiguracaoRelatorios()"
    (previewRequested)="abrirPreVisualizacao($event)"
    (configureRequested)="abrirBtnGerar($event)" />
</div>

<!-- DRAWER -->
<p-drawer
  [(visible)]="drawerVisible"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [showCloseIcon]="false"
  styleClass="report-drawer"
  (onHide)="fecharDrawer()">

  <ng-template #headless>
    <div class="drawer-shell">

      <!-- HEADER -->
      <div class="drawer-header">
        <div class="drawer-heading">
          <div
            class="card-icon"
            [ngClass]="relatorioAtual.color">
            <i [class]="relatorioAtual.icon"></i>
          </div>

          <div>
            <h2>{{ relatorioAtual.title }}</h2>
            <span>Configurar e gerar</span>
          </div>
        </div>

        <button
          type="button"
          class="icon-close"
          (click)="fecharDrawer()"
          aria-label="Fechar">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- CONTEÚDO -->
      <div class="drawer-content">

        <!-- INFORMAÇÃO -->
        <div class="info-box">
          <i class="pi pi-info-circle"></i>
          <p>
            O logótipo, a designação e o NIF impressos no cabeçalho vêm de
            <strong>Configurações › Aplicação</strong>.
          </p>
        </div>

        <!-- CABEÇALHO DO DOCUMENTO -->
        <div class="drawer-section-label">
          Cabeçalho do documento
        </div>

        <div class="document-header-preview">
          <div class="document-company">
            <div class="company-mark">
              @if (tenantConfigurationService.configuration().logoDataUrl) {
                <img [src]="tenantConfigurationService.configuration().logoDataUrl" alt="" />
              } @else {
                {{ (tenantConfigurationService.configuration().nome || 'SP').slice(0, 2).toUpperCase() }}
              }
            </div>

            <div>
              <strong>
                {{ tenantConfigurationService.configuration().nome || 'Tenant não configurado' }}
              </strong>
              <span>
                NIF {{ tenantConfigurationService.configuration().nif || '—' }}
              </span>
            </div>
          </div>
        </div>

        <div class="document-description">
          Esta identidade será usada nos documentos deste tenant.
        </div>

        <div class="customize-link">
          <i class="pi pi-cog"></i>
          Personalizar em Configurações › Aplicação
        </div>

        <!-- FILTROS -->
        <div class="drawer-section-label">
          Filtros
        </div>

        <!-- PERÍODO -->
        <div class="field">
          <label for="drawer-periodo">Período</label>
          <p-select
            inputId="drawer-periodo"
            [options]="periodos"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="periodoSelecionado"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- DATAS -->
        <div
          class="date-fields"
          [class.single-date]="['efetivos', 'faltas', 'equipamentos'].includes(relatorioSelecionado)"
          *ngIf="!['ocorrencias', 'rondas', 'postos', 'escalas'].includes(relatorioSelecionado)"
        >
          <div class="field" *ngIf="relatorioSelecionado === 'equipamentos'">
            <label for="data-aquisicao">Data de Aquisição</label>
            <input id="data-aquisicao" type="date" [(ngModel)]="dataAquisicao">
          </div>

          <div class="field" *ngIf="['efetivos', 'faltas'].includes(relatorioSelecionado)">
            <label for="data-admissao">Data de admissão</label>
            <input id="data-admissao" type="date" [(ngModel)]="dataAdmissao">
          </div>

          <ng-container *ngIf="!['efetivos', 'faltas', 'equipamentos'].includes(relatorioSelecionado)">
          <div class="field">
            <label for="data-inicio-de">
              {{ relatorioSelecionado === 'escalas' ? 'Data de início — De' : 'Data de admissão — De' }}
            </label>
            <input id="data-inicio-de" type="date" [(ngModel)]="dataInicioDe">
          </div>

          <div class="field">
            <label for="data-inicio-ate">
              {{ relatorioSelecionado === 'escalas' ? 'Data de início — Até' : 'Data de admissão — Até' }}
            </label>
            <input id="data-inicio-ate" type="date" [(ngModel)]="dataInicioAte">
          </div>
          </ng-container>
        </div>

        <!-- CLIENTE -->
        <div class="field">
          <label for="drawer-cliente">Cliente</label>
          <p-select
            inputId="drawer-cliente"
            [options]="clientes"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="clienteSelecionado"
            (ngModelChange)="onClienteChange($event)"
            [loading]="carregandoClientes"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- POSTO -->
        <div class="field">
          <label for="drawer-posto">Posto</label>
          <p-select
            inputId="drawer-posto"
            [options]="postos"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="postoSelecionado"
            [loading]="carregandoPostos"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- TIPO DE POSTO — APENAS RELATÓRIO DE POSTOS -->
        <div class="field" *ngIf="relatorioSelecionado === 'postos'">
          <label for="tipoPosto">Tipo de posto</label>
          <p-select
            inputId="tipoPosto"
            [options]="tipoPosto"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="TipoPostoId"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- PROVÍNCIA — POSTOS -->
        <div class="field" *ngIf="relatorioSelecionado === 'postos'">
          <label for="drawer-provincia">Província</label>
          <p-select
            inputId="drawer-provincia"
            [options]="provincia"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="ProvinciaId"
            (ngModelChange)="onProvinciaChange($event)"
            [loading]="carregandoProvincias"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- MUNICÍPIO — POSTOS -->
        <div class="field" *ngIf="relatorioSelecionado === 'postos'">
          <label for="drawer-municipio">Município</label>
          <p-select
            inputId="drawer-municipio"
            [options]="municipio"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="MunicipioId"
            [disabled]="ProvinciaId == null || carregandoMunicipios"
            [loading]="carregandoMunicipios"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- ESTADO DO EFETIVO -->
        <div class="field" *ngIf="relatorioSelecionado === 'efetivos'">
          <label for="drawer-estado">Estado do efetivo</label>
          <p-select
            inputId="drawer-estado"
            [options]="estadosEfetivo"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="estadoSelecionado"
            styleClass="report-select">
          </p-select>
        </div>

        <!-- FILTROS DE ESCALAS -->
        <ng-container *ngIf="relatorioSelecionado === 'escalas'">
         

          <div class="field">
            <label for="drawer-turno">Turno</label>
            <p-select
              inputId="drawer-turno"
              [options]="turnos"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="turnoSelecionado"
              [loading]="carregandoTurnos"
              appendTo="body"
              scrollHeight="240px"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label for="drawer-estado-escala">Estado da escala</label>
            <p-select
              inputId="drawer-estado-escala"
              [options]="estadosEscala"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="estadoSelecionado"
              appendTo="body"
              styleClass="report-select">
            </p-select>
          </div>
        </ng-container>

        <!-- FILTROS DE OCORRÊNCIAS -->
        <ng-container *ngIf="relatorioSelecionado === 'ocorrencias'">
          <div class="field">
            <label for="drawer-efetivo">Efetivo</label>
            <p-select
              inputId="drawer-efetivo"
              [options]="efetivosOpcoes"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="efetivoSelecionado"
              [loading]="carregandoEfetivos"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label for="drawer-ocorrencia-turno">Turno</label>
            <p-select
              inputId="drawer-ocorrencia-turno"
              [options]="turnos"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="turnoSelecionado"
              [loading]="carregandoTurnos"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label for="drawer-ronda">Ronda</label>
            <p-select
              inputId="drawer-ronda"
              [options]="tiposRonda"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="rondaSelecionada"
              [loading]="carregandoRondas"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label for="drawer-criticidade">Criticidade</label>
            <p-select
              inputId="drawer-criticidade"
              [options]="criticidades"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="criticidadeSelecionada"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label for="drawer-tipo-ocorrencia">Tipo de ocorrência</label>
            <p-select
              inputId="drawer-tipo-ocorrencia"
              [options]="tiposOcorrencia"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="tipoOcorrenciaSelecionado"
              styleClass="report-select">
            </p-select>
          </div>
        </ng-container>

        <!-- FILTROS DE RONDAS -->
        <ng-container *ngIf="relatorioSelecionado === 'rondas'">
          <div class="field">
            <label for="drawer-ronda-efetivo">Efetivo</label>
            <p-select
              inputId="drawer-ronda-efetivo"
              [options]="efetivosOpcoes"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="efetivoSelecionado"
              [loading]="carregandoEfetivos"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label for="drawer-ronda-turno">Turno</label>
            <p-select
              inputId="drawer-ronda-turno"
              [options]="turnos"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="turnoSelecionado"
              [loading]="carregandoTurnos"
              styleClass="report-select">
            </p-select>
          </div>

          <div class="field">
            <label>Estado da ronda</label>
            <label class="checkbox-field">
              <input type="checkbox" [(ngModel)]="SomenteEmcurso">
              <span>Apenas rondas em curso</span>
            </label>
          </div>
        </ng-container>

        <!-- FILTROS DE EQUIPAMENTOS -->
        <ng-container *ngIf="relatorioSelecionado === 'equipamentos'">
          <div class="field">
            <label for="drawer-tipo-equipamento">Tipo de equipamento</label>
            <p-select
              inputId="drawer-tipo-equipamento"
              [options]="tiposEquipamentos"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="TipoEquipamentoId"
              styleClass="report-select">
            </p-select>
          </div>
        </ng-container>

        <!-- FORMATO -->
        <div class="field">
          <label>Formato de saída</label>
          <div class="format-options">
            <button
              type="button"
              *ngFor="let formato of relatorioAtual.formats"
              [class.active]="formatoSelecionado === (formato === 'XLSX' ? 'xlsx' : formato.toLowerCase())"
              (click)="selecionarFormato(formato)"
              [disabled]="gerandoDocumento">
              {{ formato }}
            </button>
          </div>
        </div>

      </div>

      <!-- AÇÕES DO DRAWER -->
      <div class="drawer-actions">
        <button
          type="button"
          class="btn btn-ghost"
          (click)="abrirPreVisualizacao()"
          [disabled]="gerandoDocumento">
          <i class="pi pi-eye"></i>
          Pré-visualizar
        </button>

        <button
          type="button"
          class="btn btn-primary"
          (click)="baixarRelatorio()"
          [disabled]="gerandoDocumento">
          <i class="pi" [ngClass]="gerandoDocumento ? 'pi-spin pi-spinner' : 'pi-download'"></i>
          {{ gerandoDocumento ? 'A gerar...' : 'Gerar e descarregar' }}
        </button>
      </div>

    </div>
  </ng-template>
</p-drawer>

<!-- PRÉ-VISUALIZAÇÃO -->
<app-report-preview
  [visible]="previewVisible"
  [report]="relatorioAtual"
  [title]="previewTitulo"
  [description]="previewDescricao"
  [icon]="previewIcone"
  [columns]="previewColumns"
  [rows]="previewRows"
  [totalRecords]="previewTotalRegistos"
  [generating]="gerandoDocumento"
  (closed)="fecharPreVisualizacao()"
  (downloadRequested)="baixarRelatorio()" />
